// Long story short:
// Backend needs to receive and send id's as integers and some are negative
// Select component can't handle negative integers because it breaks
// Therefore --> transformValue

export const transformToString = (value) => {
    if (!value && isNaN(value)) return '';
    return value.toString();
};

export const transformToInteger = (value) => {
    return parseInt(value, 10);
};
